const CONSTANTS = {
    NO_REPLY_EMAIL: "noreply@readyrx.com",
    SUPPORT_EMAIL: "clientsuccess@readyrx.com",
    SUPPORT_PHONE: "(310) 878-1003",
    CANCEL_PHONE: "(424) 842-4583",
    CANCEL_URL: "https://app.readyrx.com/subscription-cancel",
    CANCEL_EMAIL: "cancel@readyrx.com",
    CANCEL_ADDRESS_1: "750 N. San Vicente Blvd, Ste. 800 West",
    CANCEL_ADDRESS_2: "West Hollywood, CA 90069",
    COMPANY_ADDRESS_1: "750 N. San Vicente Blvd, Ste. 800 West",
    COMPANY_ADDRESS_2: "West Hollywood, CA 90069",
    LEGAL_EMAIL: "legal@readyrx.com",
    INSURANCE_EMAIL: "insurance@readyrx.com", // for updating insurance info
    PRIVACY_EMAIL: "privacy@readyrx.com",
    TERMS_URL: "https://app.readyrx.com/terms",
    PRIVACY_URL: "https://app.readyrx.com/privacy",
    COMMUNICATION_POLICY_URL: "https://app.readyrx.com/communication-policy",
    UPDATE_INSURANCE_URL: "https://app.readyrx.com/insurance-update",
    LANDING_URL: "https://app.readyrx.com",
    BRAND_SITE_URL: "https://readyrx.com",
    CONSENT_URL: "https://app.readyrx.com/consent",
    CONTACT_URL: "https://app.readyrx.com/contact",
    COMPANY_NAME: "ReadyRX",
    COMPANY_NAME_PLAIN_TEXT: "ReadyRX", // how plain-text copy spells the brand; BrandText renders each one as Ready<sup>RX</sup>
    COMPANY_NAME_SPOKEN: "Ready R X", // spaced so screen readers say the letters, not "rex" or "prescription"
    COMPANY_LEGAL_NAME: "Ready Health Ventures Inc."
};

export default CONSTANTS;